import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogComponent, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FbAuctionDetailConfiguration } from '../fb-auction-detail/fb-auction-detail.configuration';
import { FbSellerInfoConfiguration } from '../fb-seller-info/fb-seller-info.configuration';
import { AuctionDetailButtonConfiguration } from '../fb-auction-detail/auction-detail-button/auction-detail-button.configuration';
import { FbAuctionConfiguration, FbAuctionConfigurationAuctions, FbTabConfiguration } from '../fb-auction/fb-auction.configuration';
import { FbAuctionCardConfiguration } from '../fb-auction/fb-auction-card/fb-auction-card.configuration';
import { BatchPreviewDTO } from 'src/app/_core/classes/BatchPreviewDTO';

@Component({
  selector: 'app-fb-auction-multiple-detail',
  templateUrl: './fb-auction-multiple-detail.component.html',
  styleUrls: ['./fb-auction-multiple-detail.component.scss']
})
export class FbAuctionMultipleDetailComponent implements OnInit {

    instance: DynamicDialogComponent;
    configuration: FbAuctionDetailConfiguration;
    sellerConfiguration: FbSellerInfoConfiguration;
    priceButtonConfiguration: AuctionDetailButtonConfiguration | null = null;
    auctionConfiguration: FbAuctionConfiguration | null = null;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, public dialogService: DialogService) {

        this.configuration = this.config.data.configuration;

    }

    ngOnInit() {

        this.setup();

    }

    private setup() {

        if (this.configuration.batch.CreatedBy)
            this.sellerConfiguration = FbSellerInfoConfiguration.create(this.configuration.batch.CreatedBy).setAvatar(this.configuration.batch.UserFile?.Endpoint ?? "");

        if (this.configuration.batch.StartingPrice)
            this.priceButtonConfiguration = AuctionDetailButtonConfiguration.create("Prezzo partenza").setPrice(this.configuration.batch.StartingPrice).setCssClass("secondary-color");

        const auctions: FbAuctionCardConfiguration[] = [];
        const conf = FbAuctionConfiguration.create()

        conf
        .setAuctions([
           FbAuctionConfigurationAuctions.create().setAuctions(auctions).setTabConfiguration(FbTabConfiguration.create("Tutte le disponibilità"))])

         this.setupBatches(this.configuration.batch, auctions);

         this.auctionConfiguration = FbAuctionConfiguration.create();
         this.auctionConfiguration = conf;

    }

    private setupBatches(batches : BatchPreviewDTO, auctions: FbAuctionCardConfiguration[]) {

        // batches.BatchAvailabilities.forEach(element => {

        //     const batch = new BatchPreviewDTO(batches);
        //     batch.BatchAvailabilities = [element];
        //     auctions.push(FbAuctionCardConfiguration.create(batch));


        // });


    }

}
